import { Link } from "react-router-dom";

import LeftArrowIcon from "~/icons/LeftArrowIcon";
import { getLink } from "~/providers/route";
import type { ITemplateUser } from "~/interfaces";
import { useTrans } from "~/hooks/useTrans";

import "./style.less";

export default function BackToProjects({
	projectId,
	checkInternalRole = "none",
}: Pick<ITemplateUser, "checkInternalRole" | "projectId">) {
	const { trans } = useTrans();

	function getLinkNavigation() {
		if (checkInternalRole === "none") {
			return getLink("projects");
		}

		return getLink("admin-projects", false, { projectId });
	}

	return <div className="backToProjects">
		<Link to={getLinkNavigation()}>
			<span className="backToProjects__itemIcon">
				<LeftArrowIcon />
			</span>
			<span className="backToProjects__itemText">
				{ checkInternalRole === "none" ? trans("my.projects") : trans("menu.adminProjects") }
			</span>
		</Link>
	</div>;
}
